import type { BoardStatus } from '@hygge/shared';

/**
 * Status dot color + human label for a board's lifecycle status. Shared by the
 * Overview header property row and the sidebar Properties card so the swatch +
 * label stay identical across both surfaces.
 */
export const STATUS_STYLE: Record<BoardStatus, { dot: string; label: string }> = {
  planning: { dot: 'bg-slate-400', label: 'Planning' },
  active: { dot: 'bg-emerald-500', label: 'Active' },
  paused: { dot: 'bg-amber-500', label: 'Paused' },
  completed: { dot: 'bg-hygge', label: 'Completed' },
  cancelled: { dot: 'bg-rose-500', label: 'Cancelled' },
  archived: { dot: 'bg-muted-foreground/50', label: 'Archived' },
};
